import { useEffect, useState } from "react";
import { Bookmark, Clock3, Trophy, UsersRound } from "lucide-react";
import { api } from "../../lib/api";

const KINDS = {
  accepted: { icon: Trophy, cls: "text-emerald-700", verb: "celebrated a win:" },
  waitlisted: { icon: Clock3, cls: "text-amber-700", verb: "is waitlisted for" },
  saved: { icon: Bookmark, cls: "text-secondary", verb: "saved" },
};

const REACTIONS = [
  { key: "heart", emoji: "❤️", label: "Send a heart" },
  { key: "clap", emoji: "👏", label: "Send a clap" },
];

// Gentle household activity feed: wins, waitlist updates and saved finds by
// any guardian — with heart/clap reactions so encouragement flows both ways.
// Private follow-up notes never appear here.
export const FamilyFeed = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/opportunities/family-feed")
      .then(({ data: d }) => setData(d))
      .catch(() => setData(null));
  }, []);

  const react = async (f, reaction) => {
    try {
      const { data: d } = await api.post("/opportunities/family-feed/react",
        { event_id: f.event_id, reaction });
      setData((prev) => ({
        ...prev,
        feed: prev.feed.map((x) => x.event_id === f.event_id
          ? { ...x, reactions: d.reactions, my_reaction: d.my_reaction } : x),
      }));
    } catch { /* a tap never shows an error */ }
  };

  if (!data?.feed?.length) return null;
  return (
    <div className="rounded-2xl border border-border bg-card p-4 space-y-2" data-testid="family-feed">
      <p className="text-sm font-bold flex items-center gap-1.5">
        <UsersRound className="h-4 w-4 text-secondary" aria-hidden="true" /> Family activity
      </p>
      {data.feed.slice(0, 8).map((f, i) => {
        const k = KINDS[f.kind];
        const Icon = k.icon;
        return (
          <div key={f.event_id} className="text-xs" data-testid={`family-feed-item-${i}`}>
            <Icon className={`inline h-3.5 w-3.5 mr-1.5 align-[-2px] ${k.cls}`} aria-hidden="true" />
            <span className="font-semibold">{f.actor}</span> {k.verb}{" "}
            <span className="font-semibold">{f.title}</span>
            <span className="text-muted-foreground">
              {" "}— {f.organization} · {new Date(f.when).toLocaleDateString()}
            </span>
            <span className="inline-flex items-center gap-1 ml-2">
              {REACTIONS.map((r) => (
                <button key={r.key} type="button" onClick={() => react(f, r.key)}
                  aria-label={r.label} aria-pressed={f.my_reaction === r.key}
                  className={`inline-flex items-center gap-0.5 rounded-full border px-1.5 py-0 text-[11px]
                    transition-transform hover:scale-110
                    ${f.my_reaction === r.key
                      ? "border-secondary bg-secondary/15 font-bold"
                      : "border-border bg-accent/40"}`}
                  data-testid={`feed-react-${r.key}-${i}`}>
                  {r.emoji}{f.reactions?.[r.key] > 0 && <span>{f.reactions[r.key]}</span>}
                </button>
              ))}
            </span>
            {f.win_note && (
              <p className="italic text-emerald-800/80 pl-5" data-testid={`family-feed-note-${i}`}>
                “{f.win_note}”
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};
